<template>
    <div id="fixedHeader" class="fixed-header">
        <statusBar></statusBar>
        <div class="pages-header">
            <div class="area_left">
                <img class="icon_toggle" :src="$themeImage('header.menuToggle')" alt="" @click="toggleSideBar">
            </div>
            <div v-if="device !== 'mobile'" class="search_btn" @click.stop="toSearch" >
                <i class="iconfont icon-sousuo"></i>
                <div class="txt"> {{ $t("home.SearchGames") }}</div>
            </div>
            <div v-if="device !== 'mobile' && isShowSport" class="sportsBox" >
                <div class="selectBtn"  @click.stop="onPageRefresh"> {{ $t("sports.home") }}</div>
                <div class="selectBtn"  @click.stop="toSports"> {{ $t("sports.title") }}</div>
            </div>
            <div class="icon_logo" :class="{'mobile_logo': device == 'mobile'}">
                <img v-if="device == 'mobile'" class="logo" :src="logoUrl2" @click.stop="onPageRefresh" />
                <img v-else class="logo" :src="logoUrl" @click.stop="onPageRefresh" />
            </div>
            <div class="user_action">
                <div></div>
                <div>
                    <div v-if="isLogin && device === 'mobile'" class="user_info">
                        <img class="icon-shuaxin" :class="{ 'turning': isRefreshingMoney }" :src="$themeImage('sidebar.refresh')" @click.stop="getUserInfo"/>
                        <div class="user_money">
                            {{ CurrencyType }}{{ allBalance }}
                        </div>
                        <div class="deposit" @click.stop="toDeposit">
                            <img :src="$themeImage('header.mobileArrow')" alt="" @click="toggleSideBar">
                        </div>
                    </div>
                    <div v-if="isLogin && device !== 'mobile'" class="user_info_pc" @click.stop="onMenuItem('Person')">
                        <img class="u_avatar" src="@/assets/person/avatar.png" />
                        <div class="u-info">
                            <div class="u-phone">
                                <span>Hi, {{ userPhone }}</span>
                                <img class="u-arrow" :src="$themeImage('header.dropdownArrow')" />
                            </div>
                            <div>ID:{{ userInfo.id }}</div>
                        </div>
                    </div>
                    <div v-if="!isLogin" class="user_login">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div v-if="isLogin" class="Notification" @click.stop="toNotification">
                        <i class="iconfont icon-xiangling"></i>
                        <div v-if="noticeNumber" class="matterNumber">{{ noticeNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
        <logoutPopup ref="logoutPopup"></logoutPopup>
    </div>
</template>

<script>
import { domainKey } from '@/common/http'
import statusBar from '@/components/statusBar'
import logoutPopup from '@/components/logoutPopup'
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { Toast } from 'vant'
export default {
    name: 'Header',
    components: { statusBar, logoutPopup },
    data() {
        return {
            domainKey,
            pathAct: '',
            isRefreshingMoney: false
        }
    },
    computed: {
        isShowSport() {
            const msg = this.$store.state.system.betSportMsg
            return msg?.brandId !== null && msg?.gameInfoId !== null
        },
        ...mapState({
            device: state => state.app.device,
            sidebar: state => state.app.sidebar
        }),
        isLogin() {
            return !!this.$store.getters.token
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        noticeNumber() {
            return this.$store.getters.noticeNumber
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.pathAct = this.$route.name
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act) {
            console.log(this.pathAct, 'this.pathAct===')
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.onNavTo({ url: act, type: 'post' })
        },
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toMy() {
            // this.$store.dispatch('user/setIsShowMyPopup', true)
            this.onNavTo({ url: '/PersonBox' })
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        toSports() {
            this.onNavTo({ url: 'Sports' })
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toNotification() {
            if (this.$route.path.indexOf('/notification') !== -1) {
                return
            }
            const params = { type: 1 }
            this.onNavTo({ url: '/notification', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    // box-shadow: 0 4px 20px #0006;

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1.2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;
        background: var(--theme-header-bg);

        .area_left{
            position: absolute;
            left: .34rem;
            display: flex;
            align-items: center;
            z-index: 8;

            .icon_toggle{
                color: rgb(174,194,228);
                font-size: .48rem;
                margin-right: .16rem;
                transition: all .3s;
                width: .52rem;
                height: .52rem;
                vertical-align: middle;
                cursor: pointer;

                &.sidebarOpened{
                    transform: rotate(180deg);
                }
            }
        }

        .sportsBox {
            display: flex;
            cursor: pointer;
            position: absolute;
            left: 256px;
            z-index: 7;
            .selectBtn {
                width: 100px;
                height: 44px;
                border: 1px solid var(--theme-header-control-border);
                background: var(--theme-header-control-bg);
                line-height: 40px;
                font-size: 23px;
            }
            & > div:first-child {
                border-radius: 20px 0 0 20px;
            }
            & > div:last-child {
                border-radius: 0 20px 20px 0;
            }
        }

        .search_btn{
            width: 150px;
            height: 44px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-left: 20px;
            position: absolute;
            left: 46px;
            z-index: 7;
            border: 1px solid var(--theme-header-control-border);
            background: var(--theme-header-control-bg);

            .txt {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // height: 44px;
                // line-height: 42px;
                font-size: 15px;
                color: var(--theme-input-placeholder);
            }

            .iconfont {
                font-weight: bold;
                height: 44px;
                width: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
                vertical-align: middle;
                color: var(--theme-input-placeholder);
            }
        }

        &>div.icon_logo {
            position: absolute;
            height: 100%;
            left: calc(50% + 70px);
            transform: translateX(-50%);
            top: 0;
            z-index: 3;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            padding: 0 60px;

            .logo {
                height: .78rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }

            &.mobile_logo{
                width: auto !important;
                left: .76rem !important;
                transform: translate(0, -50%) !important;
                background: transparent;
                top: 50% !important;
                padding: 0;
                .logo {
                    height: .84rem !important;
                    filter: drop-shadow(0 0 .08rem rgba($font-theme-color, .28));
                }
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            // max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            &>div:last-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .user_info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: .66rem;
                // padding: .06rem .08rem;
                border-radius: .16rem;
                overflow: hidden;
                box-sizing: border-box;
                border: .01rem solid transparent;
                background-image:
                    linear-gradient(to right, var(--theme-header-control-bg), var(--theme-header-control-bg)),
                    var(--theme-header-control-border-gradient);
                background-origin: border-box;
                background-clip: content-box, border-box;

                .icon-shuaxin {
                    width: .28rem;
                    height: .28rem;
                    // vertical-align: middle;
                    margin-left: .15rem;

                    &.turning {
                        animation: rotateAni 0.2s linear infinite;
                    }

                    @keyframes rotateAni {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(-360deg);
                        }
                    }
                }
                .user_money {
                    padding: 0 .08rem;
                    border-radius: .2rem;
                    margin-top: 0;
                    font-size: .28rem;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .deposit {
                    height: 100%;
                    // border-radius: .17rem;
                    font-size: .5rem;
                    margin-left: .08rem;
                    cursor: pointer;
                    width: .68rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--theme-header-accent-bg);

                    & > img{
                        width: .24rem;
                        height: .24rem;
                        vertical-align: middle;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-image: linear-gradient(90deg, transparent, rgba(255, 255, 255, .5), transparent);
                        background-repeat: no-repeat;
                        animation: bgmove-1badf8a4 linear 2.5s infinite;
                    }

                    @keyframes bgmove-1badf8a4 {
                        0% {
                            background-position: -200px 0
                        }

                        to {
                            background-position: 400px 0
                        }
                    }
                }
            }

            .user_info_pc{
                position: relative;
                cursor: pointer;
                border-radius: 30px;
                padding: 4px 7px 4px 4px;
                height: 48px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                gap: 0;

                .u_avatar{
                    margin-right: 8px;
                    height: 50px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 50px;
                    vertical-align: middle;
                }
                .u-info{
                    line-height: 1.02;
                    font-size: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;
                    text-align: left;

                    & > div:first-child{
                        white-space: nowrap;
                        display: flex;
                        align-items: center;
                        color: var(--theme-bright-text);
                        margin-bottom: 8px;
                        &.u-phone{
                            & > img.u-arrow{
                                width: 18px;
                                height: 18px;
                                vertical-align: middle;
                                margin-left: 8px;
                            }
                        }
                    }
                    & > div:last-child{
                        font-size: 12px;
                        margin-top: 2px;
                        white-space: nowrap;
                        color: var(--theme-soft-text);
                    }
                }
            }

            .Notification {
                width: 42px;
                height: 42px;
                border-radius: 8px;
                margin: 0 0 0 18px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                background: var(--theme-header-control-bg);
                border: 1px solid var(--theme-surface-border);

                &:hover {
                    filter: brightness(1.05);
                }

                &>i {
                    font-size: .36rem;
                    color: var(--theme-soft-text);
                }

                .matterNumber{
                    position: absolute;
                    height: .36rem;
                    width: .36rem;
                    border-radius: 50px;
                    background: $font-error-color;
                    font-size: .24rem;
                     color: var(--theme-bright-text);top:-.1rem;
                    right: -.1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .user_login {
                font-size: .26rem;
                height: .7rem;
                line-height: .7rem;
                display: flex;
                align-items: center;

                .login {
                    cursor: pointer;
                    text-align: center;
                    padding: 0 .18rem;
                    border-radius: .1rem;
                    border: .01rem solid var(--theme-surface-border);
                    background: var(--theme-header-control-bg);
                    color: var(--theme-bright-text);
                }

                .sign_up {
                    cursor: pointer;
                    text-align: center;
                    border-radius: .15rem;
                    padding: 0 .18rem;
                    margin-right: .12rem;
                    font-weight: bold;
                    background: var(--theme-header-accent-bg);
                    color: var(--theme-active-text);
                }
            }
        }
    }
}

@media screen and (max-width: 767px) {
    .pages-header .area_left .icon_toggle {
        width: .83rem !important;
        height: .83rem !important;
        padding: .1rem !important;
        margin-left: -.1rem !important;
        box-sizing: border-box;
    }

    .pages-header {
        padding-left: 0 !important;
        justify-content: space-between;
    }

    .pages-header .area_left {
        left: .12rem !important;
        z-index: 4;
    }
}

</style>
